const genDroppableStrings = (length, baseString) => {
  const baseStringLC = baseString.toLowerCase();
  const arr = Array(length)
    .fill(baseStringLC)
    .map((item, index) => {
      return `${item}-layout-area-${index + 1}`;
    });
  return arr;
};

const DROPPABLE_LOCATION_IDS = {
  SOURCE_TRAY_ID: 'source-tray',
  SINGLE_COLUMN_AREA_ID: 'single-column-layout-area',
  DOUBLE_COLUMN_FIRST_AREA_ID: 'double-column-layout-area-1',
  DOUBLE_COLUMN_SECOND_AREA_ID: 'double-column-layout-area-2',
  DOUBLE_ROW_FIRST_AREA_ID: 'double-row-layout-area-1',
  DOUBLE_ROW_SECOND_AREA_ID: 'double-row-layout-area-2',
  SINGLE_COLUMN_AREA_80: 'single-column-layout-area-80',
  SINGLE_COLUMN_AREA_60: 'single-column-layout-area-60',
  SINGLE_COLUMN_AREA_40: 'single-column-layout-area-40',
  SINGLE_COLUMN_TEXT_OVERFLOW_AREA: 'single-column-layout-text-overflow-area',
  TWO_ROW_THREE_AREA_100_50_50: [
    'two-row-three-area-layout-top-area-1',
    'two-row-three-area-layout-bottom-area-1',
    'two-row-three-area-layout-bottom-area-2',
  ],
  TWO_ROW_TWO_COLUMN_AREA_67_33: [
    'two-row-two-column-layout-area-67-1',
    'two-row-two-column-layout-area-33-1',
    'two-row-two-column-layout-area-67-2',
    'two-row-two-column-layout-area-33-2',
  ],
  TWO_COLUMN_L_40_1A_R_60_1A: genDroppableStrings(
    2,
    'TWO_COLUMN_L_40_1A_R_60_1A'
  ),
  TWO_COLUMN_L_67_1A_R_33_1A: genDroppableStrings(
    2,
    'TWO_COLUMN_L_67_1A_R_33_1A'
  ),
  TWO_COLUMN_L_80_1A_R_20_1A: genDroppableStrings(
    2,
    'TWO_COLUMN_L_80_1A_R_20_1A'
  ),
  TWO_ROW_T_80_1A_B_20_1A: genDroppableStrings(2, 'TWO_ROW_T_80_1A_B_20_1A'),
  TWO_ROW_T_60_1A_B_40_1A: genDroppableStrings(2, 'TWO_ROW_T_60_1A_B_40_1A'),
  TWO_ROW_T_20_1A_B_80_1A: genDroppableStrings(2, 'TWO_ROW_T_20_1A_B_80_1A'),
  THREE_COLUMN: genDroppableStrings(3, 'THREE_COLUMN'),
  THREE_ROWS: genDroppableStrings(3, 'THREE_ROWS'),
  TWO_COLUMN_L_50_2A_R_50_1A: genDroppableStrings(
    3,
    'TWO_COLUMN_L_50_2A_R_50_1A'
  ),
  TWO_ROW_T_50_2A_B_50_1A: genDroppableStrings(3, 'TWO_ROW_T_50_2A_B_50_1A'),
  TWO_COLUMN_L_67_2A_R_33_1A: genDroppableStrings(
    3,
    'TWO_COLUMN_L_67_2A_R_33_1A'
  ),
  TWO_ROW_T_50_1A_B_50_2A: genDroppableStrings(3, 'TWO_ROW_T_50_1A_B_50_2A'),
  TWO_COLUMN_L_50_3A_R_50_1A: genDroppableStrings(
    4,
    'TWO_COLUMN_L_50_3A_R_50_1A'
  ),
  TWO_COLUMN_TWO_ROW_50_2A_50_2A: genDroppableStrings(
    4,
    'TWO_COLUMN_TWO_ROW_50_2A_50_2A'
  ),
  TWO_COLUMN_TWO_ROW_67_2A_33_2A: genDroppableStrings(
    4,
    'TWO_COLUMN_TWO_ROW_67_2A_33_2A'
  ),
  THREE_COLUMN_TWO_ROW: genDroppableStrings(6, 'THREE_COLUMN_TWO_ROW'),
};

export default DROPPABLE_LOCATION_IDS;
